export default __webpack_public_path__ + "static/media/Ballroll_00308.5727d2d9.png";